/**
 * QuizQuestionSkeleton
 *
 * A skeleton loading state for the QuizQuestion component
 */

import React from 'react'
import { cn } from '@/lib/utils'

interface QuizQuestionSkeletonProps {
  className?: string
}

export const QuizQuestionSkeleton: React.FC<QuizQuestionSkeletonProps> = ({ className }) => {
  return (
    <div
      className={cn(
        'border-border bg-card my-4 flex animate-pulse flex-col overflow-hidden rounded-lg border shadow-sm transition-all',
        className
      )}
    >
      {/* Header */}
      <div className="flex items-center border-b p-3">
        <div className="flex items-center gap-2">
          <div className="size-4 rounded-full bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-4 w-24 rounded bg-gray-200 dark:bg-gray-700"></div>
        </div>
      </div>

      {/* Question content */}
      <div className="p-4">
        {/* Question text */}
        <div className="mb-6 space-y-2">
          <div className="h-5 w-3/4 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-5 w-5/6 rounded bg-gray-200 dark:bg-gray-700"></div>
        </div>

        {/* Options */}
        <div className="mb-6 space-y-3">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="size-5 rounded-full bg-gray-200 dark:bg-gray-700"></div>
              <div className="h-5 w-2/3 rounded bg-gray-200 dark:bg-gray-700"></div>
            </div>
          ))}
        </div>

        {/* Controls */}
        <div className="mt-6 flex items-center gap-2 border-t pt-3">
          <div className="h-8 w-20 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-8 w-24 rounded bg-gray-200 dark:bg-gray-700"></div>
        </div>
      </div>
    </div>
  )
}
